import config, { AppType, getViteEnv } from "../config";
import { DocumentTemplateType } from "../../../api/src/types";

const isPostnup = config.appType === AppType.POSTNUP;
const isPrenup = config.appType === AppType.PRENUP;

// ─── Core brand names ────────────────────────────────────────────────
export const BRAND_NAME = isPostnup ? "Postnup.com" : "HelloPrenup";
export const BRAND_LEGAL_ENTITY = isPostnup
  ? "Postnup.com"
  : "Hello Prenup, Inc.";

// ─── Document type labels ────────────────────────────────────────────
export const DOCUMENT_TYPE = isPostnup ? "postnup" : "prenup";
export const DOCUMENT_TYPE_FULL = isPostnup
  ? "postnuptial agreement"
  : "prenuptial agreement";
export const DOCUMENT_TYPE_CAPITALIZED = isPostnup ? "Postnup" : "Prenup";
export const DOCUMENT_TYPE_FULL_CAPITALIZED = isPostnup
  ? "Postnuptial Agreement"
  : "Prenuptial Agreement";
export const PREMARITAL_OR_POSTMARITAL = isPostnup
  ? "postmarital"
  : "premarital";

export const PARTNER_NAME_POSTNUP = "spouse";
export const PARTNER_NAME_PRENUP = "fiancé";
export const PARTNER_NAME = isPostnup
  ? PARTNER_NAME_POSTNUP
  : PARTNER_NAME_PRENUP;
export const PARTNER_NAME_CAPITALIZED_POSTNUP = "Spouse";
export const PARTNER_NAME_CAPITALIZED_PRENUP = "Fiancé";
export const PARTNER_NAME_CAPITALIZED = isPostnup
  ? PARTNER_NAME_CAPITALIZED_POSTNUP
  : PARTNER_NAME_CAPITALIZED_PRENUP;

// ─── URLs ────────────────────────────────────────────────────────────
// TODO: Replace postnup.com links with actual postnup.com URLs once available
export const BRAND_DOMAIN = isPostnup ? "postnup.com" : "helloprenup.com";
export const APP_DOMAIN = isPostnup ? "app.postnup.com" : "app.helloprenup.com";
export const TERMS_URL = isPostnup
  ? "https://postnup.com/terms-of-use/" // TODO: confirm postnup.com terms URL
  : "https://helloprenup.com/terms-of-use/";
export const PRIVACY_URL = isPostnup
  ? "https://postnup.com/privacy-policy/" // TODO: confirm postnup.com privacy URL
  : "https://helloprenup.com/privacy-policy/";
export const HELP_URL = isPostnup
  ? "https://help.postnup.com/en/" // TODO: confirm postnup.com help URL
  : "https://help.helloprenup.com/en/";
export const SUPPORT_EMAIL = isPostnup
  ? "support@postnup.com" // TODO: confirm postnup.com support email
  : "support@helloprenup.com";
export const NOTARY_INFO_URL = isPostnup
  ? "https://postnup.com/notarization/" // TODO: confirm postnup.com notary URL
  : "https://helloprenup.com/notary/";

// ─── Profile ─────────────────────────────────────────────────────────
// The countdown is only rendered for prenups (postnups have no real deadline).
export const COUNTDOWN_LABEL = 'Countdown to "I Do"';

// ─── Helper ──────────────────────────────────────────────────────────
export { isPostnup, isPrenup };
export const AVERAGE_SAVED_AMOUNT = isPostnup ? "$7,500" : "$8,000";

export const isDocumentTemplatePostnup = (templateId: string) => {
  return templateId === config.postnupTemplateId;
};

export const getDocumentType = (templateId: string) => {
  return isDocumentTemplatePostnup(templateId) ? "Postnup" : "Prenup";
};

export const getRedirectionBaseUrl = (
  documentTemplateType: DocumentTemplateType,
) => {
  const hostname = window.location.hostname;
  if (hostname === "localhost") {
    switch (documentTemplateType) {
      case DocumentTemplateType.PRENUP:
        return (
          getViteEnv("VITE_PRENUP_WEB_BASE_URL") ??
          getViteEnv("VITE_WEB_BASE_URL") ??
          "http://localhost:5173"
        );
      case DocumentTemplateType.POSTNUP:
        return (
          getViteEnv("VITE_POSTNUP_WEB_BASE_URL") ??
          getViteEnv("VITE_WEB_BASE_URL") ??
          "http://localhost:5174"
        );
      default:
        return "";
    }
  } else if (
    hostname === "dev.helloprenup.com" ||
    hostname === "dev.postnup.com"
  ) {
    switch (documentTemplateType) {
      case DocumentTemplateType.PRENUP:
        return "https://dev.helloprenup.com";
      case DocumentTemplateType.POSTNUP:
        return "https://dev.postnup.com";
      default:
        return "";
    }
  } else if (
    hostname === "staging.helloprenup.com" ||
    hostname === "staging.postnup.com"
  ) {
    switch (documentTemplateType) {
      case DocumentTemplateType.PRENUP:
        return "https://staging.helloprenup.com";
      case DocumentTemplateType.POSTNUP:
        return "https://staging.postnup.com";
      default:
        return "";
    }
  } else if (
    hostname === "app.helloprenup.com" ||
    hostname === "app.postnup.com"
  ) {
    switch (documentTemplateType) {
      case DocumentTemplateType.PRENUP:
        return "https://app.helloprenup.com";
      case DocumentTemplateType.POSTNUP:
        return "https://app.postnup.com";
      default:
        return "";
    }
  } else {
    return "";
  }
};
